export const routePaths = {
  // Public
  landing: '/',
  scan: '/scan',
  authCallback: '/auth/callback',
  authGuestCallback: '/auth/guest-callback',
  logout: '/logout',
  eventPublic: '/events/:eventCode',
  eventMyRequests: '/events/:eventCode/my-requests',

  // Protected
  me: '/me',

  // DJ
  djDashboard: '/dj',
  djEvents: '/dj/events',
  djCreateEvent: '/dj/events/new',
  djEventDetail: '/dj/events/:eventId',
  djEventRequests: '/dj/events/:eventId/requests',
  djSpotify: '/dj/spotify',

  // Not found
  notFound: '*',
};
